import { render, staticRenderFns } from "./ImportBoothTypesComp.vue?vue&type=template&id=5b0d3f67"
import script from "./ImportBoothTypesComp.vue?vue&type=script&lang=ts"
export * from "./ImportBoothTypesComp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports